import {
  DatePicker as DatePickerAntd,
  Input as InputAntd,
  Row as RowAntd,
} from 'antd';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

export const RangerPicker = styled(DatePickerAntd.RangePicker)`
  border-radius: 6px;
`;

export const Container = styled(RowAntd)`
  padding: 20px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.span`
  display: block;
  color: #4f4f4f;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 13px;
`;

export const FormButtons = styled(RowAntd)`
  margin-top: 16px;
`;

export const CSVExportButton = styled(CSVLink)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 7px;
  border: 1px solid #6a6a6a;
  border-radius: 6px;
  margin: 6px;

  cursor: ${props => (props.loading ? 'wait' : 'pointer')};
`;

export const FiltroInput = styled(InputAntd)`
  width: 188px;
  margin-bottom: 8px;
  display: block;

  .ant-table-filter-trigger-container {
    position: relative;
  }
`;
